var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpCenterAccountAccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91659 12.25V11.0833C9.91659 10.4645 9.67075 9.871 9.23317 9.43342C8.79558 8.99583 8.20209 8.75 7.58325 8.75H2.91659C2.29775 8.75 1.70425 8.99583 1.26667 9.43342C0.829085 9.871 0.583252 10.4645 0.583252 11.0833V12.25M13.4166 12.25V11.0833C13.4162 10.5663 13.2441 10.0641 12.9274 9.65552C12.6106 9.24692 12.1672 8.95508 11.6666 8.82583M9.33325 1.82583C9.83516 1.95434 10.28 2.24624 10.5977 2.65551C10.9154 3.06479 11.0878 3.56815 11.0878 4.08625C11.0878 4.60435 10.9154 5.10771 10.5977 5.51699C10.28 5.92626 9.83516 6.21816 9.33325 6.34667M7.58325 4.08333C7.58325 5.372 6.53858 6.41667 5.24992 6.41667C3.96125 6.41667 2.91659 5.372 2.91659 4.08333C2.91659 2.79467 3.96125 1.75 5.24992 1.75C6.53858 1.75 7.58325 2.79467 7.58325 4.08333Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenterAccountAccess);
export default __webpack_public_path__ + "static/media/help-center-account-access.0ea7acb4c878c179d15d27b689705c80.svg";
export { ForwardRef as ReactComponent };